import { API_BASE_URL } from '../../env';
import { ApiReturnType } from '../../interfaces/api/api';

export default {
  getDomains: (): ApiReturnType => ({
    endpoint: `${API_BASE_URL}/v2/agency/domains`,
    headers: { 'Content-Type': 'application/json' },
    method: 'GET',
  }),
  getAllAgency: (): ApiReturnType => ({
    endpoint: `${API_BASE_URL}/v2/agency/agencies`,
    headers: { 'Content-Type': 'application/json' },
    method: 'GET',
  }),
};
